/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeliverySystemAdminDto } from '../models/DeliverySystemAdminDto';
import type { DeliverySystemType } from '../models/DeliverySystemType';
import type { DeliverySystemValueType } from '../models/DeliverySystemValueType';
import type { Pagination1OfDeliverySystemAdminDto } from '../models/Pagination1OfDeliverySystemAdminDto';
import type { PostPutBranchDeliverySystemRequestAdmin } from '../models/PostPutBranchDeliverySystemRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchDeliverySystemsService {
    /**
     * **Required Policy:** `ViewBranchDeliverySystems`
     * @returns Pagination1OfDeliverySystemAdminDto OK
     * @throws ApiError
     */
    public static getBranchDeliverySystemAdmin({
        name,
        type,
        valueType,
        page,
        limit,
    }: {
        name?: string,
        type?: DeliverySystemType,
        valueType?: DeliverySystemValueType,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDeliverySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchdeliverysystems',
            query: {
                'name': name,
                'type': type,
                'valueType': valueType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliverySystems`
     * @returns DeliverySystemAdminDto OK
     * @throws ApiError
     */
    public static postBranchDeliverySystemAdmin({
        requestBody,
    }: {
        requestBody?: PostPutBranchDeliverySystemRequestAdmin,
    }): CancelablePromise<DeliverySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branchdeliverysystems',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDeliverySystems`
     * @returns DeliverySystemAdminDto OK
     * @throws ApiError
     */
    public static getBranchDeliverySystemAdmin1({
        branchDeliverySystemId,
    }: {
        branchDeliverySystemId: number,
    }): CancelablePromise<DeliverySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}',
            path: {
                'branchDeliverySystemId': branchDeliverySystemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliverySystems`
     * @returns DeliverySystemAdminDto OK
     * @throws ApiError
     */
    public static putBranchDeliverySystemAdmin({
        branchDeliverySystemId,
        requestBody,
    }: {
        branchDeliverySystemId: number,
        requestBody?: PostPutBranchDeliverySystemRequestAdmin,
    }): CancelablePromise<DeliverySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}',
            path: {
                'branchDeliverySystemId': branchDeliverySystemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBranchDeliverySystems`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchDeliverySystemAdmin({
        branchDeliverySystemId,
    }: {
        branchDeliverySystemId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branchdeliverysystems/{branchDeliverySystemId}',
            path: {
                'branchDeliverySystemId': branchDeliverySystemId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
